import React from 'react';
import './reviews.css'
import C2wReviewCard from '../../../../common/C2wHome/courseDetails/reviewCard';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

function C2wReviews( {courseData} ) {

  /**
 * @constant renderedReviewsCard
 * @author Vishal Lohbande
 * @description Maps over the `courseData` array to render a list of `C2wReviewCard` components.
 * Each component receives an individual review object (`obj`) as a prop.
 * 
 * @returns {JSX.Element[]} Array of `C2wReviewCard` components
 * 
 * Usage:
 * Used to display a list of reviews related to the course.
 */

  return (
    <div className='C2wReviews_ctn'>
      <div className='C2wCoureseDetailComponentHeading_ctn'>
        <div className='C2wReviews_testimonialHeading'>{'Testimonials'}</div>
        <div className='heading'>
          {`${'What '} `}
          <span className='headingSpan'>{`${'Students say '}`}</span>
          {'about this course?'}
        </div>
      </div>
      <div className='C2wReviews_holder'>
          {/* {renderedReviewsCard} */}
          <Swiper 
          modules={[Autoplay]}
          slidesPerView={3}
          spaceBetween={115}
            navigation={false}
            loop={false}
            className=" "
            autoplay={{
              delay:3000, 
              disableOnInteraction: false,
            }}
            breakpoints={{
              360: {   
                slidesPerView: 1,
                spaceBetween: 30,
              },
              1358: {   
                slidesPerView: 3,
                spaceBetween: 45,
              },
              1366: {   
                slidesPerView: 3,
                spaceBetween: 45,
              },
              1440: {   
                slidesPerView: 3,
                spaceBetween: 40,
              },
              1536: {   
                slidesPerView: 3,
                spaceBetween: 70,
              },
              1540: {   
                slidesPerView: 3,
                spaceBetween: 70,
              },
              1920: {
                slidesPerView: 3,
                spaceBetween: 115,
              }
            }}
          >
          {courseData?.map((obj, index) => (
          <SwiperSlide className='C2wReviewSwiperSlide'>
            <C2wReviewCard obj={obj} />
          </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  )
}

export default C2wReviews
